import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\User\UsersExportController::__invoke
* @see app/Http/Controllers/User/UsersExportController.php
* @route '/api/user/users-export'
*/
const UsersExportController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: UsersExportController.url(options),
    method: 'post',
})

UsersExportController.definition = {
    methods: ["post"],
    url: '/api/user/users-export',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\User\UsersExportController::__invoke
* @see app/Http/Controllers/User/UsersExportController.php
* @route '/api/user/users-export'
*/
UsersExportController.url = (options?: RouteQueryOptions) => {
    return UsersExportController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\User\UsersExportController::__invoke
* @see app/Http/Controllers/User/UsersExportController.php
* @route '/api/user/users-export'
*/
UsersExportController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: UsersExportController.url(options),
    method: 'post',
})

export default UsersExportController